import { standardCheckoutRoutes, trialCheckoutRoutes } from "@jti/fe-common";

type PGSCallbackUrls = {
  paymentSuccessfulUrl: string;
  paymentFailedUrl: string;
};

type GetPgsCallbackUrlsOptions = {
  orderId: string;
  paymentToken: string;
  isFreeTrial: boolean | undefined;
};

export const getPgsCallbackUrls = ({
  orderId,
  paymentToken,
  isFreeTrial = false,
}: GetPgsCallbackUrlsOptions): PGSCallbackUrls => {
  const checkoutRoutes = isFreeTrial ? trialCheckoutRoutes : standardCheckoutRoutes;

  const { origin, pathname } = new URL(window.location.toString());
  const baseUrl = `${origin}${pathname}#`;

  const paymentSuccessfulUrl = `${baseUrl}${checkoutRoutes.payment.getSuccessPaymentUrl(orderId, paymentToken)}`;
  const paymentFailedUrl = `${baseUrl}${checkoutRoutes.payment.getFailedPaymentUrl(orderId)}`;

  return {
    paymentSuccessfulUrl,
    paymentFailedUrl,
  };
};
